export const getCurrencySymbol = (currency: string | null | undefined) => {
  switch (currency) {
    case "EUR":
      return "€";
    case "USD":
      return "$";
    case "GBP":
      return "£";
    case "CHF":
      return "₣";
    case "AED":
      return "Dhs";
    default:
      return currency || "";
  }
};

export default getCurrencySymbol;
